(() => {
  'use strict';

  if (!window.WagmadeTheme) return;

  window.WagmadeTheme.register('search-page', '[data-wm-portable-section="search-page"]', (root) => {
    let controller;

    return {
      init() {
        const input = root.querySelector('.wm-search-page__field input[type="search"]');
        const clear = root.querySelector('[data-wm-search-clear]');
        if (!input || !clear) return;

        controller = new AbortController();
        clear.addEventListener('click', () => {
          input.value = '';
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.focus();
        }, { signal: controller.signal });
      },
      destroy() {
        if (controller) controller.abort();
      },
    };
  });

  window.WagmadeTheme.init(document);
})();
